import { Link } from "react-router-dom";
import { Facebook, BookMarked, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#14171D] border-t border-[#D4AF37]/5 pt-24 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <Link
              to="/"
              className="font-serif text-4xl text-[#F4F4F6] inline-block mb-4"
              data-testid="footer-logo"
            >
              Ellie<span className="text-[#D4AF37]">.</span>Stone
            </Link>
            <p className="text-[#A0A4AE] max-w-sm text-sm leading-relaxed">
              Spinner of star-crossed lovers and impossible kingdoms. New
              chapters, every season.
            </p>
            <div className="flex items-center gap-5 mt-6">
              <a href="https://www.facebook.com/profile.php?id=61589686628261" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="text-[#F4F4F6]/40 hover:text-[#D4AF37] transition-colors">
                <Facebook size={18} />
              </a>
              <a href="https://www.goodreads.com/author/show/70183152.Ella_Raine?ref=nav_profile_l" target="_blank" rel="noopener noreferrer" data-testid="footer-goodreads" aria-label="Goodreads" className="text-[#F4F4F6]/40 hover:text-[#D4AF37] transition-colors">
                <BookMarked size={18} />
              </a>
              <a href="mailto:elliestoneauthor@yahoo.com" data-testid="footer-email" aria-label="Email" className="text-[#F4F4F6]/40 hover:text-[#D4AF37] transition-colors">
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <div className="overline mb-5">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/books" className="text-[#F4F4F6]/70 hover:text-[#D4AF37] transition-colors">Books</Link></li>
              <li><Link to="/characters" className="text-[#F4F4F6]/70 hover:text-[#D4AF37] transition-colors">Characters</Link></li>
              <li><Link to="/ella-raine" className="text-[#F4F4F6]/70 hover:text-[#D4AF37] transition-colors">Ella Raine</Link></li>
              <li><Link to="/about" className="text-[#F4F4F6]/70 hover:text-[#D4AF37] transition-colors">About</Link></li>
              <li><Link to="/news" className="text-[#F4F4F6]/70 hover:text-[#D4AF37] transition-colors">News</Link></li>
              <li><Link to="/contact" className="text-[#F4F4F6]/70 hover:text-[#D4AF37] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">The Letter</div>
            <p className="text-[#A0A4AE] text-sm leading-relaxed mb-4">
              Quiet dispatches from the writing room. No noise, just starlight.
            </p>
            <Link to="/#newsletter" data-testid="footer-subscribe" className="btn-ghost text-sm">
              Subscribe →
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-[#D4AF37]/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#6C7280] text-xs font-mono">
            © {new Date().getFullYear()} ELLIE STONE. ALL RIGHTS RESERVED.
          </p>
          <p className="text-[#6C7280] text-xs font-mono tracking-widest">
            PARANORMAL ROMANCE ✦ URBAN FANTASY ✦ COZY MYSTERY
          </p>
        </div>
      </div>
    </footer>
  );
}
